import React, { useState } from 'react';
import { 
  Accordion, 
  AccordionSummary, 
  AccordionDetails, 
  Typography, 
  Box 
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: 'What is Lsnto?',
    answer: 'Lsnto is a music streaming platform built by artists, for artists. We connect independent musicians directly with fans who truly care about music, ensuring fair pay and authentic discovery without major label interference.'
  },
  {
    question: 'How do I join as a fan?',
    answer: 'You can join our fan waitlist to get early access to the platform. Simply fill out the form on our fan waitlist page with your details, and we\'ll notify you when we launch. No credit card required!'
  },
  {
    question: 'How do artists get paid on Lsnto?',
    answer: 'Artists on Lsnto receive fair compensation for their work. We use a transparent payment model that ensures artists get a significantly larger share compared to traditional streaming platforms. Revenue is distributed based on actual listening time and engagement.'
  },
  {
    question: 'What devices and platforms are supported?',
    answer: 'Lsnto is available on web browsers, iOS and Android mobile apps, and supports CarPlay and Android Auto for in-car listening. We\'re constantly working to expand our platform support.'
  },
  {
    question: 'How do I delete my account or data?',
    answer: 'You can request account or data deletion by filling out the "Delete My Data" form below. We take your privacy seriously and will process your request within 30 days in accordance with GDPR and data protection regulations.'
  },
];

const SupportFAQ: React.FC = () => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange = (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box>
      <Typography 
        variant="h4" 
        sx={{ 
          fontWeight: 700, 
          mb: 3, 
          textAlign: 'center',
          fontFamily: '"Poppins", sans-serif'
        }}
      >
        Frequently Asked Questions
      </Typography>

      {faqData.map((faq, index) => (
        <Accordion
          key={index}
          expanded={expanded === `panel${index}`}
          onChange={handleChange(`panel${index}`)}
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            backdropFilter: 'blur(10px)',
            borderRadius: '8px !important',
            mb: 2,
            border: '1px solid rgba(255, 255, 255, 0.1)',
            '&:before': {
              display: 'none',
            },
            '&.Mui-expanded': {
              margin: '0 0 16px 0',
            }
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: '#E4FF1A' }} />}
            sx={{
              '& .MuiAccordionSummary-content': {
                margin: '16px 0',
              }
            }}
          >
            <Typography 
              sx={{ 
                fontWeight: 600,
                fontFamily: '"Poppins", sans-serif',
                color: '#fff'
              }}
            >
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontFamily: '"Poppins", sans-serif',
                color: 'rgba(255, 255, 255, 0.85)',
                lineHeight: 1.6
              }}
            >
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default SupportFAQ;






